module.exports = __webpack_public_path__ + "9779d9a1/img/cadBim.e369a02a.png";